<i18n>
{
	"en": {
		"driverNotContactable": "Driver missing contact info",
		"saveBeforeBroadcastMessage": "Your unsaved changes will not be included unless you save first. Do you wish to save before broadcasting leg to drivers?",
		"legBroadcastedToDrivers": "Leg broadcasted to drivers",
		"failedToBroadcastLeg": "Could not broadcast leg to drivers",
		"noDriversInLeg": "Cannot send a leg without drivers to Confirm",
		"needToSaveTrip": "You need to save the trip at least once before anything can be sent to Confirm",
		"appBroadcast": "Broadcast leg to the drivers",
		"close": "Close"
	},
	"no": {
		"driverNotContactable": "Sjåfør mangler kontaktinfo",
		"saveBeforeBroadcastMessage": "Dine endringer er ikke lagret og vil derfor ikke bli med om du ikke lagrer først. Vil du lagre før legen kringkastes til sjåførene?",
		"legBroadcastedToDrivers": "Leg kringkastet til sjåfører",
		"failedToBroadcastLeg": "Kunne ikke kringkaste til sjåfører",
		"noDriversInLeg": "Kan ikke sende en leg uten sjåfører til Confirm",
		"needToSaveTrip": "Du må lagre turen minst én gang før noe kan sendes til Confirm",
		"appBroadcast": "Kringkast leg til sjåførene",
		"close": "Lukk"
	}
}
</i18n>

<template>
	<t-dialog
		:isShown="isShown"
		focusFirstOnShow
		alwaysRememberFocus
		:title="$t('appBroadcast')"
		@close="$emit('close')"
	>
		<div class="content">
			<BroadcastDriversInput
				:selectedItems="broadcastDrivers"
				:errors="errors"
				@select="addBroadcastDriver"
				@set:selected="setBroadcastDrivers"
			/>
			<t-tag-container
				v-if="broadcastDrivers && broadcastDrivers.length"
				:items="broadcastDrivers"
				displayKey="name"
				@change="setBroadcastDrivers"
			/>
		</div>

		<template
			#footer
		>
			<div class="footer">
				<t-button
					:value="$t('appBroadcast')"
					appearance="primary"
					:intent="wasBroadcasted ? 'success' : 'default'"
					type="bp"
					iconBefore="globe"
					@click="beforeBroadcastToDrivers(trip.id)"
				/>
				<t-button
					:value="$t('close')"
					appearance="primary"
					@click="$emit('close')"
				/>
			</div>
		</template>

		<ConfirmCancelDialog
			:isShown="showSaveBeforeBroadcastDialog"
			:message="$t('saveBeforeBroadcastMessage')"
			@cancel="showSaveBeforeBroadcastDialog = false"
			@yes="saveBeforeBroadcastToDrivers"
			@no="onBroadcastToDrivers"
		/>
	</t-dialog>
</template>

<script>
import BroadcastDriversInput from './BroadcastDriversInput';
import ConfirmCancelDialog from '@/components/modals/ConfirmCancelDialog';

import { mapActions, mapState } from '../store/newTrip.store.js';

export default {
	name: 'BroadcastDriversDialog',
	components: {
		BroadcastDriversInput,
		ConfirmCancelDialog,
	},
	props: {
		broadcastDrivers: Array,
		errors: Array,
		isShown: Boolean,
		wasBroadcasted: Boolean,
		legNumber: Number,
		legId: String,
	},
	data() {
		return {
			showSaveBeforeBroadcastDialog: false,
		};
	},
	computed: {
		...mapState([
			'trip',
			'dirty',
		]),
		currentViaLocation() {
			return (this.currentViaLocationIndex >= 0) ? this.viaLocations[this.currentViaLocationIndex] : false;
		},
	},

	inject: ['saveTrip'], // Defined in newTrip.vue

	methods: {
		...mapActions([
			'setLegBroadcastDrivers',
			'broadcastToDrivers',
		]),

		addBroadcastDriver(driver) {
			if (this.broadcastDrivers.includes(driver)) {
				console.error(`Allready added ${driver.name}`);
			} else {
				this.setLegBroadcastDrivers({ legNumber: this.legNumber, broadcastDrivers: [...this.broadcastDrivers, driver] });
			}
		},
		setBroadcastDrivers(broadcastDrivers) {
			this.setLegBroadcastDrivers({ legNumber: this.legNumber, broadcastDrivers });
		},

		beforeBroadcastToDrivers() {
			if (this.dirty) {
				this.showSaveBeforeBroadcastDialog = true;
			} else {
				this.onBroadcastToDrivers();
			}
		},
		async saveBeforeBroadcastToDrivers() {
			this.showSaveBeforeBroadcastDialog = false;
			let savedSuccessfully = await this.saveTrip({ validateDrivers: true });
			if (!savedSuccessfully) return;
			this.onBroadcastToDrivers();
		},

		async onBroadcastToDrivers() {
			this.showSaveBeforeBroadcastDialog = false;
			this.$notify({ clean: true });
			try {
				await this.broadcastToDrivers(this.legId);
				this.$notify({
					type: 'success',
					title: this.$t('legBroadcastedToDrivers'),
				});
			} catch (e) {
				console.log(e);
				this.$notify({
					type: 'error',
					title: this.$te(e.message) ? this.$t(e.message) : this.$t('failedToBroadcastLeg'),
					duration: -1,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.footer {
	width: 100%;
	display: flex;
	justify-content: space-between
}

.content {
	display: grid;
	grid-row-gap: 20px;
}
</style>
